import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: true,
};

export const initFacebookPixel = (pixelId: string) => {
  if (!pixelId) {
    console.warn("Facebook Pixel ID is missing");
    return;
  }
  ReactPixel.init(pixelId, undefined, options);
  ReactPixel.pageView();
};

export const trackEvent = (eventName: string, params: Record<string, any> = {}) => {
  ReactPixel.track(eventName, params);
};

export const trackLead = () => trackEvent('Lead');
export const trackContact = () => trackEvent('Contact');
export const trackSubscribe = () => trackEvent('Subscribe');
export const trackPurchase = (value: number, currency: string = 'USD') =>
trackEvent('Purchase', { value, currency });
